import { render, staticRenderFns } from "./ReportMenu.vue?vue&type=template&id=b1a2623e&scoped=true"
import script from "./ReportMenu.vue?vue&type=script&lang=js"
export * from "./ReportMenu.vue?vue&type=script&lang=js"
import style0 from "./ReportMenu.vue?vue&type=style&index=0&id=b1a2623e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a2623e",
  null
  
)

export default component.exports